import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("foreignObject", {
        width: "11.867",
        height: "8.407",
        x: ".941",
        y: "2.732"
      }, [
        _createElementVNode("div", {
          xmlns: "http://www.w3.org/1999/xhtml",
          style: {"backdrop-filter":"blur(.62px)","clip-path":"url(#b)","height":"100%","width":"100%"}
        })
      ]),
      _createElementVNode("path", {
        stroke: "#A7A7B1",
        "stroke-width": ".879",
        d: "M5.183 4.412h5.633c.155 0 .243 0 .306.006h.002v.003a4 4 0 0 1-.058.3l-.907 4.196c-.036.164-.057.265-.08.34-.02.07-.033.087-.036.09a.26.26 0 0 1-.109.09.3.3 0 0 1-.096.015c-.077.006-.179.006-.346.006H3.138l.012-.039.356-1.166c.335-1.093.76-2.492 1.02-3.355.098-.322.12-.363.139-.387a.26.26 0 0 1 .107-.08c.028-.01.073-.019.411-.019Z",
        "data-figma-bg-blur-radius": "1.241",
        style: {"stroke":"color(display-p3 .6543 .6543 .6951)","stroke-opacity":"1"}
      }),
      _createElementVNode("path", {
        fill: "#6E6E7D",
        d: "M9.965 9.894h-.01l.043-.006q-.015.003-.033.006m-4.751-7.87c.15 0 .226 0 .297.016q.09.021.172.07c.062.036.116.089.224.193l.064.061c.108.105.163.157.225.194a.6.6 0 0 0 .29.084l.178.002h2.494c.4 0 .6 0 .753.079a.7.7 0 0 1 .3.3c.056.108.072.242.076.456h-4.13a1.5 1.5 0 0 1-.408-.165c-.172-.101-.31-.241-.388-.317l-.063-.061-.035-.034H3.396l-.036.033-.226.213c-.181.17-.404.284-.643.338v4.239l-.078.255c-.219.71-.282.919-.388 1.266-.057.189-.094.321-.131.417a1 1 0 0 1-.112-.124l-.071-.114c-.099-.19-.099-.441-.099-.942V3.218c0-.317.257-.574.574-.574a.5.5 0 0 0 .271-.079l.075-.058.228-.213c.107-.1.161-.152.223-.188a.6.6 0 0 1 .17-.066c.069-.016.143-.017.29-.017z",
        style: {"fill":"color(display-p3 .4296 .4296 .4915)","fill-opacity":"1"}
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", {
        id: "b",
        transform: "translate(-.941 -2.732)"
      }, [
        _createElementVNode("path", { d: "M5.183 4.412h5.633c.155 0 .243 0 .306.006h.002v.003a4 4 0 0 1-.058.3l-.907 4.196c-.036.164-.057.265-.08.34-.02.07-.033.087-.036.09a.26.26 0 0 1-.109.09.3.3 0 0 1-.096.015c-.077.006-.179.006-.346.006H3.138l.012-.039.356-1.166c.335-1.093.76-2.492 1.02-3.355.098-.322.12-.363.139-.387a.26.26 0 0 1 .107-.08c.028-.01.073-.019.411-.019" })
      ]),
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h11.25v11.25H0z",
          style: {"fill":"#fff","fill-opacity":"1"},
          transform: "translate(.375 .375)"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }